import React, { useContext } from 'react'
import { SessionContextStore } from '../../../context/SessionContext'
import { MilesRangeSlider, Collapse } from './components'
import { GaugeIcon } from './assets'
import './styles.scss'

export default () => {
  const {
    user: { userVehicles, affiliateCode },
  } = useContext(SessionContextStore)
  return (
    <Collapse
      open={`${6 * userVehicles.length + 1}rem`}
      close="1.5rem"
      title={
        <div className="flex align-center">
          <GaugeIcon />
          <div style={{ marginLeft: '.5rem' }}>Estimated annual mileage</div>
          <div style={{ marginLeft: 'auto', textDecoration: 'underline' }}>
            {userVehicles.length === 1 && userVehicles[0].estimated_mileage_value} Miles
          </div>
        </div>
      }
    >
      <div>
        {userVehicles &&
          userVehicles.map(vehicle => (
            <div key={vehicle.id}>
              <MilesRangeSlider vehicle={vehicle} affiliateCode={affiliateCode} />
            </div>
          ))}
      </div>
    </Collapse>
  )
}
